export class ServerErrorCodes {
  //#region Core
  public static UnhandledServerError = 'UnhandledServerError';
  public static InvalidModel = 'InvalidModel';
  public static ResourceNotFound = 'ResourceNotFound';
  public static UserNotRegistered = 'UserNotRegistered';
  public static InvalidGrant = 'invalid_grant'; // from identity server
  //#endregion Core
}
